import { render, staticRenderFns } from "./TakipAcTebligatGideriForm.vue?vue&type=template&id=3b601167&scoped=true"
import script from "./TakipAcTebligatGideriForm.vue?vue&type=script&lang=ts"
export * from "./TakipAcTebligatGideriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b601167",
  null
  
)

export default component.exports